import { useNavigate } from "react-router-dom";

interface Props {
  unitId: number;
}

export function ReportsTab({ unitId }: Props) {
  const nav = useNavigate();
  return (
    <section className="space-y-3" data-testid="unit-reports">
      <h2 className="text-sm font-semibold">Reportes</h2>
      <p className="text-sm text-muted-200">
        Genera reportes filtrados por esta unidad desde la pantalla
        principal de reportes. Los exports de ruta (GPX/KML/CSV/PDF) se
        generan desde la pestaña <strong>Playback</strong>.
      </p>
      <button
        className="btn-primary"
        onClick={() => nav("/reports?unit=" + unitId)}
      >
        Abrir reportes
      </button>
    </section>
  );
}
